import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getCopPageCategoriesData = async () => {
  const data = await fetchData(ENDPOINTS.GET.COP_PAGE_CATEGORIES, {
    method: METHODS.GET,
  });
  return data;
};
